/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import EcalLogo from '../../commons/images/EcalLogo';
import ContentContainer from '../components/contentContainer';
import useInAppRedirect from './useInAppRedirect';
import WidgetDialog from '../components/dialogs';
import TransitionAvatar from '../components/transitionAvatar';
import TitleHeader from '../components/titleHeader';

import useWidgetTheme from '../../commons/widgetTheme';

import useUIStates from '../../store/models/uistates/useUIStates';
import { useAppStore } from '../../store/models/app';
import { useStyles } from './styles';

import { 
    getCalendarLogo,
    getCalendarName,
} from '../../commons/utils/utils';

function InAppRedirect (props) {

    useInAppRedirect();

    const {
        translate,
        translateWithValues,
    } = useTranslator();

    const {
        selectedCalendar,
    } = useUIStates();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const appStore = useAppStore();

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    if (!appStore.hasLanguage || appStore.initializedAsInAppRedirect) {
        return  (
            <ContentContainer>
                <Grid>
                    <EcalLogo />
                </Grid>
                <Grid className={classes.text}>
                    {translate(TranslationIds.COMPONENT_LOADING)}...
                </Grid>
            </ContentContainer>           
        );
    }

    return (
        <React.Fragment>
            <ContentContainer>
                <WidgetDialog
                    isShowBackButton={false}
                    name={'InAppRedirect'}
                >
                     <Grid className={classes.content}>

                        <Grid className={classNames([classes.titleHeader])}>
                            <TitleHeader
                                widget={widget}
                                widgetTheme={widgetTheme}
                                title={translateWithValues(TranslationIds.USER_CONNECTING_TO_CALENDAR, { calendar: getCalendarName(selectedCalendar) })}
                            />
                        </Grid>

                        <TransitionAvatar
                            calendarLogoURL={getCalendarLogo(selectedCalendar)}
                            clientLogoURL={widget?.logo}
                        />

                        <Grid className={classNames([classes.oauthBeforeBody])}>
                            <Grid className={classNames([classes.bodyMessages])}>
                                <Typography variant={'body1'}>
                                    {translateWithValues(TranslationIds.USER_WAITING_FOR_CALENDAR, { calendar: getCalendarName(selectedCalendar) })}
                                </Typography>
                            </Grid>
                            <Grid className={classNames([classes.bodyMessages])}>
                                <Typography variant={'body1'}>
                                    {translate(TranslationIds.USER_PLEASE_LOGIN)}
                                </Typography>
                            </Grid>
                            <Grid className={classNames([classes.bodyMessages, classes.nothingHappenedMsg])}>
                                <Typography variant={'body1'}>
                                    {translate(TranslationIds.USER_NOTHING_HAPPENED)}&nbsp;
                                </Typography>

                                <Link
                                    className={classes.loginLink}
                                    onClick={() => {
                                        appStore.launchOauthPage();
                                    }}
                                >
                                    {translate(TranslationIds.USER_CLICK_HERE_TO_LOGIN)}
                                </Link>
                            </Grid>
                        </Grid>
                     </Grid>
                    
                </WidgetDialog>
            </ContentContainer>
        </React.Fragment>
    );
}

InAppRedirect.propTypes = {
    text: PropTypes.string,
};

export default observer(InAppRedirect);